import React from "react";
import clsx from "clsx";

interface SkeletonProps {
  className?: string;
  animate?: boolean;
  children?: React.ReactNode;
}

const Skeleton = ({ className, animate = true, children }: SkeletonProps) => {
  return (
    <div
      className={clsx(
        "overflow-hidden bg-gray-200 dark:bg-theme-color-light",
        animate && "animate-pulse",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Skeleton;
